import React from 'react'
import './css/app1.css'

export default function SubFooter() {
  return (
   <>
   
   <div className="container footermain">
    <div className="row row-cols-4 submain">
        <div className="col conatinitems">
            <h5 class="headinglist">Design & Development</h5>
            <ul class="lowerList">
                <li>Website Designing</li>
                <li>Website Development</li>
                <li>E-Commerce Web Development</li>
                <li>E-Commerce Web Design</li>
                <li>WordPress Website Designing</li>
                <li>WordPress Website Development</li>
                <li>App Development</li>
                <li>Website Maintenance</li>
                <li>Ad Campaign Creatives</li>
                <li>Newsletter Design</li>
                <li>Responsive Website Designing</li>
                <li>Website Migration Services</li>
                <li>Content Management</li>
                <li>Website Hosting Service</li>

                

            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Ads Management</h5>
            <ul class="lowerList">
                <li>Google Ads Management</li>
                <li>Pay Per Click (PPC) Advertising</li>
                <li>Google Display Advertising</li>
                <li>Google Performance Max Ads</li>
                <li>Remarketing Ads | Advertising</li>
                <li>Google Paid Search Ads | Advertising</li>
            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Search Engine Optimization</h5>
            <ul class="lowerList">
                <li>Keyword Research</li>
                <li>Search Engine Optimisation</li>
                <li>Search Engine Optimisation Audit</li>
                <li>Content Writing</li>
                <li>Content Marketing</li>
                <li>E-Commerce Optimization</li>
                <li>Browser Compatibility</li>
                <li>Accessibility Implementation</li>
                <li>SEO for Charity Organizations</li>
                <li>Markups</li>
            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Social Media Advertising</h5>
            <ul class="lowerList">
                <li>Facebook Advertising</li>
                <li>Linkedin Advertising</li>
                <li>YouTube Advertising</li>
                <li>Instagram Advertising</li>
                <li>TiK Tok Advertising</li>
                <li>Snap Chat Advertising</li>
                <li>Twitter Advertising</li>

            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Strategy & Positioning</h5>
            <ul class="lowerList">
                <li>Digital Strategy</li>
<li>Digital Campaign Planning</li>
<li>Social Media Management</li>
<li>Digital Marketing Review</li>
<li>Digital Marketing Consulting</li>
<li>Email Marketing Services</li>


                

            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">UI / UX</h5>
            <ul class="lowerList">
                <li>Ul Design</li>
<li>Information Architecture</li>
<li>Personas</li>
<li>Accessibility</li>
<li>Content Strategy</li>
<li>User Experience</li>
<li>User Testing</li>

            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Web Development Platform</h5>
            <ul class="lowerList">
                <li>Magento Website Development</li>
<li>Woocommerce Website Development</li>
<li>Shopify Website Development</li>
<li>Vue.js Website Development</li>
<li>Express.js Website Development</li>
<li>Next.js Website Development</li>
<li>React Website Development</li>
<li>Node Website Development</li>
<li>Mean Website Development</li>
<li>Laravel Website Development</li>
<li>PHP Website Development</li>
<li>CodeIgniter Website Development</li>
<li>Angular Website Development</li>
<li>MongoDB Website Development</li>
<li>Python Website Development</li>
<li>Flutter APP Development</li>
<li>React Native APP Development</li>

            </ul>

        </div>
        <div className="col conatinitems">
            <h5 class="headinglist">Graphic Designs</h5>
            <ul class="lowerList">
                <li>Logo</li>
<li>Flyers</li>
<li>Brochures</li>
<li>Business card</li>
<li>Social Media Posts</li>
<li>Branding</li>
<li>Video Editing</li>
<li>Mockups</li>
<li>Banners</li>
<li>Standee</li>


            </ul>

        </div>

    </div>
   </div>
   </>
  )
}
